import { InfiniteData, useInfiniteQuery, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { FIRST_PAGE, MAX_PER_PAGE } from 'constants/constants';
import { DeveloperLogPage, DeveloperLogsLevelEnum, DeveloperLogsTypeEnum } from 'gql/graphql';
import { gql } from 'graphql-request';
import { omit } from 'lodash';
import { TGenericError } from 'types/TGenericError';
import { buildQueryKey } from 'utils/buildQueryKey';
import clientUtil from 'utils/clientUtil';

type TData = InfiniteData<DeveloperLogPage>;

type TVariables = {
  fromDate?: Date;
  toDate?: Date;
  level?: DeveloperLogsLevelEnum;
  type: DeveloperLogsTypeEnum;
  page?: number;
  perPage?: number;
};

const MOCK: TVariables = {
  type: DeveloperLogsTypeEnum.Any,
  page: FIRST_PAGE,
  fromDate: undefined,
  toDate: undefined,
  level: undefined,
  perPage: MAX_PER_PAGE
};

export const useDeveloperLogs = (
  variables: TVariables = MOCK,
  options: UseInfiniteQueryOptions<unknown, TGenericError, TData>
) => {
  const client = clientUtil();

  const graphql = gql`
    query developerLogs(
      $fromDate: ISO8601DateTime
      $toDate: ISO8601DateTime
      $level: DeveloperLogsLevelEnum
      $type: DeveloperLogsTypeEnum
      $page: Int
    ) {
      clientAccount {
        name
        developerLogs(
          fromDate: $fromDate
          toDate: $toDate
          level: $level
          type: $type
          page: $page
        ) {
          nodes {
            id
            level
            payload
            type
            message
            createdAt
          }
          pagesCount
        }
      }
    }
  `;

  const filters = omit(variables, 'page');

  return useInfiniteQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['developerLogs', ...buildQueryKey(filters)],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
